// extracted by mini-css-extract-plugin
export default {"main-title":"MainTitle_main-title__hD2W3","right-fill":"MainTitle_right-fill__jdyzO","left-fill":"MainTitle_left-fill__mmdmr"};